// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__zjjzR","icon":"SortAdornment_icon__wOj3y","up":"SortAdornment_up__29K4b","down":"SortAdornment_down__WAkrr","active":"SortAdornment_active__3G1PU"};